// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_4m-2";
export var blackBorderOnHover = "_4m-7";
export var cell = "_4m-6";
export var cellContainer = "_4m-3";
export var checked = "_4m-8";
export var disabled = "_4m-5";
export var featuredIconCellContainer = "_4m-9";
export var featuredIconTextContainer = "_4m-b";
export var featuredIconWrapper = "_4m-a";
export var noBorder = "_4m-c";
export var orangeSelectedRow = "_bz-3";
export var overflowableText = "_4m-0";
export var overflowableTextContainer = "_4m-1";
export var row = "_4o-0";
export var rowCheckboxCell = "_4m-4";
export var selectableTable = "_bz-2";